export default __webpack_public_path__ + "static/media/loc-arte-10.1eb3a4c7.webp";